import GenericContextInputItemDialog from './GenericContextInputItemDialog';
import { IntegrationEventRefModel } from '../../Models/DomainServiceModel';
import useApiIntegrationEvents from '../../Hooks/useApiIntegrationEvents';
import { useQuery } from '@tanstack/react-query';
import useFlowQueries from '../../Hooks/useFlowQueries';

type IntegrationEventInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	integrationEventRef: IntegrationEventRefModel | undefined;
	onIntegrationEventRefChange: (integrationEventRef: IntegrationEventRefModel | undefined) => void;
};

export function IntegrationEventInputDialog({ open, setOpen, integrationEventRef, onIntegrationEventRefChange }: IntegrationEventInputDialogProps) {
	const flowsQueries = useFlowQueries();
	const { data: existingIntegrationEvent } = useQuery(flowsQueries.queryIntegrationEventByRef(integrationEventRef));

	return (
		<GenericContextInputItemDialog
			open={open}
			setOpen={setOpen}
			item={existingIntegrationEvent}
			onItemChange={(item, context) =>
				onIntegrationEventRefChange?.(
					item ? ({ Id: item.id, Name: item.name, ContextId: item.contextId, ContextName: context?.name } as IntegrationEventRefModel) : undefined
				)
			}
			itemsOfContext={useApiIntegrationEvents}
			what="Integration Event"
			descriptionProperty="description"
		/>
	);
}
